const get = (name: string): string | null => {
  if (typeof window === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  if (match) return match[2];
  return null;
};

const remove = (name: string, domain?: string) => {
  if (typeof window === 'undefined') return;
  document.cookie = `${name}=; Path=/; ${domain ? `domain=${domain};` : ''} Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};

const set = (name: string, value: string, date?: Date) => {
  if (typeof window === 'undefined') return;

  const expiredDate = date || new Date();

  if (!date) expiredDate.setFullYear(expiredDate.getFullYear() + 10);

  document.cookie = `${name}=${value}; path=/; expires=${expiredDate.toUTCString()}`;
};

export const CookieHelper = {
  get,
  set,
  remove,
};
